import apiClient from './apiClient';

export const compareMaterials = async payload => (await apiClient.post('/materials/comparison', payload)).data;
